<template>
  <div class="select" ref="root">
    <label v-if="title" class="select__title">{{ title }}</label>

    <div
      class="select__control"
      :class="{ 'select__control--open': open }"
      @click.stop="toggle"
      tabindex="0"
    >
      <div class="select__value">
        <i
          v-if="selectedOption && selectedOption.icon"
          :class="selectedOption.icon"
          class="select__value-icon"
        ></i>
        <span class="select__value-label">{{
          selectedOption ? selectedOption.label : placeholder
        }}</span>
      </div>

      <i class="fas fa-chevron-down select__arrow"></i>
    </div>

    <ul v-if="open" class="select__list" @click.stop>
      <li
        v-for="opt in options"
        :key="opt.value"
        class="select__item"
        @click.stop="select(opt)"
      >
        <i v-if="opt.icon" :class="opt.icon" class="select__item-icon"></i>
        <span class="select__item-label">{{ opt.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import "./Select.css";

export default {
  name: "Select",
  props: {
    initialValue: {
      type: [Object],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Selecione",
    },
  },

  data() {
    return {
      open: false,
      selectedOption: null,
    };
  },

  mounted() {
    if (this.initialValue) {
      this.selectedOption = this.initialValue;
    }
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },

    close() {
      this.open = false;
    },

    handleDocumentClick(event) {
      const root = this.$refs.root;
      if (!root) return;
      if (!root.contains(event.target)) {
        this.close();
      }
    },

    select(opt) {
      this.selectedOption = opt;
      this.$emit("select", this.selectedOption);
      this.open = false;
    },
  },
};
</script>
